export const en = {
    administration: 'Administration',
    'advanced-forecast-description':
        'Estimated expenses for different display regions and keywords with approximate CPC.',
    'budget-forecast': 'Budget forecast',
    'campaigns-of-client': 'Client campaigns',
    create: 'Create campaign',
    'deals-list': 'List of deals {count}',
    'internal-ads-search': 'Search for internal ads',
    library: 'Library',
    marketers: 'Marketing experts',
    'my-campaigns': 'My campaigns',
    'my-clients': 'My clients',
    products: 'Products',
    recommendations: 'Recommendations',
    'recommendations-tooltip-content':
        'Yandex.Direct generates new recommendations for your campaigns several times a day. Take a look at the latest estimations.',
    'recommendations-tooltip-header': 'Recommendations for campaign improvement',
    search: 'Search',
    tools: 'Tools',
    'turbo-landing-constructor': 'Turbo Page Builder',
    'word-stat': 'Keyword selection',
    'word-stat-description':
        'Information about how many Yandex users search for a particular keyword per month, along with other search terms that are similar to your keyword.'
};
